export default {
  price: "VehiclePrice"
};
